module.exports = __webpack_public_path__ + "img/index_yewu_icon_yuanq.85100896.png";